module.exports = __webpack_public_path__ + "img/tab3.4f2441dd.png";